import styled from "styled-components";

export const TitleBigWrapper = styled.h4`
  height: 36px;
  font-size: 32px;
  margin: 10px;
  color: ${({ theme }) => theme.colors.orange};
  margin: ${(props) => (props.margin ? props.margin : "10px")};
`;
